import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const apiBaseUrl = "https://apis.mju.ac.th/arch/";
export default function ApiGenerator() {
    const { jsonfile } = useParams();
    const [resData, setResData] = useState([]);
    let resProf,
        resAssoc,
        resAssist,
        resDr,
        resLecturer = [];
    const result = [];

    const getApi = async (apiPath) => {
        const res = await axios.get(`${apiBaseUrl}v1/${apiPath}`, {
            headers: {
                Authorization:
                    "Bearer 2b693e161b70f7ac034e7659278362d8f51cb8018a5a67ce6a90f0db49657de30ef360d11d2385b7",
            },
        });
        setResData(res ? res.data : []);
        res && console.log("%cAPI Res:", "color:yellow", res.data);
    };

    function genLecturersJson(resData) {
        if (
            resData.filter((item) => item.titlePosition.startsWith("ศ."))
                .length > 0
        ) {
            result.push({
                category: "ศาสตราจารย์",
                users: resData.filter((item) =>
                    item.titlePosition.startsWith("ศ.")
                ),
            });
            // result.push({"users" : resData.filter(
            //     (item) => item.titlePosition === "ศ."
            // )});
        }

        if (
            resData.filter((item) => item.titlePosition.startsWith("รศ."))
                .length > 0
        ) {
            result.push({
                category: "รองศาสตราจารย์",
                users: resData.filter((item) =>
                    item.titlePosition.startsWith("รศ.")
                ),
            });
            // result.push({"users" : resData.filter(
            //     (item) => item.titlePosition.includes("รศ.")
            // )});
            // result.users.push([resData.filter(
            //     (item) => item.titlePosition === "รศ."
            // )]);
        }

        if (resData.filter((item) => item.titlePosition.startsWith("ผศ."))) {
            result.push({
                category: "ผู้ช่วยศาสตราจารย์",
                users: resData.filter((item) =>
                    item.titlePosition.startsWith("ผศ.")
                ),
            });
            // result.push({"users" : resData.filter(
            //     (item) => item.titlePosition === "ผศ."
            // )});
        }

        if (resData.filter((item) => item.titlePosition.startsWith("อ."))) {
            result.push({
                category: "อาจารย์",
                users: resData.filter((item) =>
                    item.titlePosition.startsWith("อ.")
                ),
            });
            // result.push({"users" : resData.filter(
            //     (item) => item.titlePosition === "อ."
            // )});
        }
    }

    function genOfficersJson(resData) {
        let resultData = [];

        function pushing(condition, resData) {}

        // adminPositionType : "ผู้อำนวยการสำนักงานคณบดี"
        function genDirector(index = 0, cate = "ผู้อำนวยการสำนักงานคณบดี") {
            result.push({
                category: cate,
                users: resData.filter(
                    (item) => item.adminPositionType === cate
                ),
            });

            return result;
        }

        // งานบริหารและธุรการ
        function genAdmin(index = 1, cate = "งานบริหารและธุรการ") {
            result.push({
                category: cate,
                users: [],
            });

            // pushing(resData.filter(
            //     (item) =>
            //         item.section === cate &&
            //         item.positionLevel &&
            //         item.positionLevel.includes("หัวหน้างาน")
            // ).length > 0);

            if (
                resData.filter(
                    (item) =>
                        item.section === cate &&
                        item.positionLevel &&
                        item.positionLevel.includes("หัวหน้างาน")
                ).length > 0
            ) {
                result[index].users.push(
                    resData.filter(
                        (item) =>
                            item.section === cate &&
                            item.positionLevel &&
                            item.positionLevel.includes("หัวหน้างาน")
                    )[0]
                );
            }

            if (
                resData.filter(
                    (item) =>
                        item.section === cate &&
                        item.positionLevel === "ชำนาญการ"
                ).length > 0
            ) {
                resData
                    .filter(
                        (item) =>
                            item.section === cate &&
                            item.positionLevel === "ชำนาญการ"
                    )
                    .map((item) => result[index].users.push(item));
            }

            if (
                resData.filter(
                    (item) =>
                        item.section === cate &&
                        item.positionLevel === "ปฏิบัติการ"
                ).length > 0
            ) {
                resData
                    .filter(
                        (item) =>
                            item.section === cate &&
                            item.positionLevel === "ปฏิบัติการ"
                    )
                    .map((item) => result[index].users.push(item));
            }

            if (
                resData.filter(
                    (item) =>
                        item.section === cate &&
                        item.positionLevel === "ปฏิบัติงาน"
                ).length > 0
            ) {
                resData
                    .filter(
                        (item) =>
                            item.section === cate &&
                            item.positionLevel === "ปฏิบัติงาน"
                    )
                    .map((item) => result[index].users.push(item));
            }

            if (
                resData.filter(
                    (item) =>
                        item.section === cate && item.positionLevel === null
                ).length > 0
            ) {
                resData
                    .filter(
                        (item) =>
                            item.section === cate && item.positionLevel === null
                    )
                    .map((item) => result[index].users.push(item));
            }

            return result;
        }

        // งานคลังและพัสดุ
        function genFinance(index = 2, cate = "งานคลังและพัสดุ") {
            result.push({
                category: cate,
                users: [],
            });

            if (
                resData.filter(
                    (item) =>
                        item.section === cate &&
                        item.positionLevel &&
                        item.positionLevel.includes("หัวหน้างาน")
                ).length > 0
            ) {
                result[index].users.push(
                    resData.filter(
                        (item) =>
                            item.section === cate &&
                            item.positionLevel &&
                            item.positionLevel.includes("หัวหน้างาน")
                    )[0]
                );
            }

            if (
                resData.filter(
                    (item) =>
                        item.section === cate &&
                        item.positionLevel === "ชำนาญการ"
                ).length > 0
            ) {
                resData
                    .filter(
                        (item) =>
                            item.section === cate &&
                            item.positionLevel === "ชำนาญการ"
                    )
                    .map((item) => result[index].users.push(item));
            }

            if (
                resData.filter(
                    (item) =>
                        item.section === cate &&
                        item.positionLevel === "ปฏิบัติการ"
                ).length > 0
            ) {
                resData
                    .filter(
                        (item) =>
                            item.section === cate &&
                            item.positionLevel === "ปฏิบัติการ"
                    )
                    .map((item) => result[index].users.push(item));
            }

            if (
                resData.filter(
                    (item) =>
                        item.section === cate &&
                        item.positionLevel === "ปฏิบัติงาน"
                ).length > 0
            ) {
                resData
                    .filter(
                        (item) =>
                            item.section === cate &&
                            item.positionLevel === "ปฏิบัติงาน"
                    )
                    .map((item) => result[index].users.push(item));
            }

            if (
                resData.filter(
                    (item) =>
                        item.section === cate && item.positionLevel === null
                ).length > 0
            ) {
                resData
                    .filter(
                        (item) =>
                            item.section === cate && item.positionLevel === null
                    )
                    .map((item) => result[index].users.push(item));
            }

            return result;
        }

        // งานนโยบาย แผน และประกันคุณภาพ
        function genPlan(index = 3, cate = "งานนโยบาย แผน และประกันคุณภาพ") {
            result.push({
                category: cate,
                users: [],
            });

            if (
                resData.filter(
                    (item) =>
                        item.section === cate &&
                        item.positionLevel &&
                        item.positionLevel.includes("หัวหน้างาน")
                ).length > 0
            ) {
                result[index].users.push(
                    resData.filter(
                        (item) =>
                            item.section === cate &&
                            item.positionLevel &&
                            item.positionLevel.includes("หัวหน้างาน")
                    )[0]
                );
            }

            // if (
            //     resData.filter(
            //         (item) =>
            //             item.section === cate &&
            //             item.positionLevel === "ชำนาญการ"
            //     ).length > 0
            // ) {
            //     resData
            //         .filter(
            //             (item) =>
            //                 item.section === cate &&
            //                 item.positionLevel === "ชำนาญการ"
            //         )
            //         .map((item) => result[index].users.push(item));
            // }

            if (
                resData.filter(
                    (item) =>
                        item.section === cate &&
                        item.positionLevel === "ปฏิบัติการ"
                ).length > 0
            ) {
                resData
                    .filter(
                        (item) =>
                            item.section === cate &&
                            item.positionLevel === "ปฏิบัติการ"
                    )
                    .map((item) => result[index].users.push(item));
            }

            // if (
            //     resData.filter(
            //         (item) =>
            //             item.section === cate &&
            //             item.positionLevel === "ปฏิบัติงาน"
            //     ).length > 0
            // ) {
            //     resData
            //         .filter(
            //             (item) =>
            //                 item.section === cate &&
            //                 item.positionLevel === "ปฏิบัติงาน"
            //         )
            //         .map((item) => result[index].users.push(item));
            // }

            // if (
            //     resData.filter(
            //         (item) =>
            //             item.section === cate && item.positionLevel === null
            //     ).length > 0
            // ) {
            //     resData
            //         .filter(
            //             (item) =>
            //                 item.section === cate && item.positionLevel === null
            //         )
            //         .map((item) => result[index].users.push(item));
            // }

            return result;
        }

        // งานบริการการศึกษาและกิจการนักศึกษา
        function genEdu(
            index = 4,
            cate = "งานบริการการศึกษาและกิจการนักศึกษา"
        ) {
            result.push({
                category: cate,
                users: [],
            });

            if (
                resData.filter(
                    (item) =>
                        item.section === cate &&
                        item.positionLevel &&
                        item.positionLevel.includes("หัวหน้างาน")
                ).length > 0
            ) {
                result[index].users.push(
                    resData.filter(
                        (item) =>
                            item.section === cate &&
                            item.positionLevel &&
                            item.positionLevel.includes("หัวหน้างาน")
                    )[0]
                );
            }

            // if (
            //     resData.filter(
            //         (item) =>
            //             item.section === cate &&
            //             item.positionLevel === "ชำนาญการ"
            //     ).length > 0
            // ) {
            //     resData
            //         .filter(
            //             (item) =>
            //                 item.section === cate &&
            //                 item.positionLevel === "ชำนาญการ"
            //         )
            //         .map((item) => result[index].users.push(item));
            // }

            if (
                resData.filter(
                    (item) =>
                        item.section === cate &&
                        item.positionLevel === "ปฏิบัติการ"
                ).length > 0
            ) {
                resData
                    .filter(
                        (item) =>
                            item.section === cate &&
                            item.positionLevel === "ปฏิบัติการ"
                    )
                    .map((item) => result[index].users.push(item));
            }

            if (
                resData.filter(
                    (item) =>
                        item.section === cate &&
                        item.positionLevel === "ปฏิบัติงาน"
                ).length > 0
            ) {
                resData
                    .filter(
                        (item) =>
                            item.section === cate &&
                            item.positionLevel === "ปฏิบัติงาน"
                    )
                    .map((item) => result[index].users.push(item));
            }

            // if (
            //     resData.filter(
            //         (item) =>
            //             item.section === cate && item.positionLevel === null
            //     ).length > 0
            // ) {
            //     resData
            //         .filter(
            //             (item) =>
            //                 item.section === cate && item.positionLevel === null
            //         )
            //         .map((item) => result[index].users.push(item));
            // }

            return result;
        }

        // งานบริการวิชาการและวิจัย
        function genServe(index = 5, cate = "งานบริการวิชาการและวิจัย") {
            result.push({
                category: cate,
                users: [],
            });

            if (
                resData.filter(
                    (item) =>
                        item.section === cate &&
                        item.positionLevel &&
                        item.positionLevel.includes("หัวหน้างาน")
                ).length > 0
            ) {
                result[index].users.push(
                    resData.filter(
                        (item) =>
                            item.section === cate &&
                            item.positionLevel &&
                            item.positionLevel.includes("หัวหน้างาน")
                    )[0]
                );
            }

            if (
                resData.filter(
                    (item) =>
                        item.section === cate &&
                        item.positionLevel === "ชำนาญการ"
                ).length > 0
            ) {
                resData
                    .filter(
                        (item) =>
                            item.section === cate &&
                            item.positionLevel === "ชำนาญการ"
                    )
                    .map((item) => result[index].users.push(item));
            }

            if (
                resData.filter(
                    (item) =>
                        item.section === cate &&
                        item.positionLevel === "ปฏิบัติการ"
                ).length > 0
            ) {
                resData
                    .filter(
                        (item) =>
                            item.section === cate &&
                            item.positionLevel === "ปฏิบัติการ"
                    )
                    .map((item) => result[index].users.push(item));
            }

            if (
                resData.filter(
                    (item) =>
                        item.section === cate &&
                        item.positionLevel === "ปฏิบัติงาน"
                ).length > 0
            ) {
                resData
                    .filter(
                        (item) =>
                            item.section === cate &&
                            item.positionLevel === "ปฏิบัติงาน"
                    )
                    .map((item) => result[index].users.push(item));
            }

            if (
                resData.filter(
                    (item) =>
                        item.section === cate && item.positionLevel === null
                ).length > 0
            ) {
                resData
                    .filter(
                        (item) =>
                            item.section === cate && item.positionLevel === null
                    )
                    .map((item) => result[index].users.push(item));
            }

            return result;
        }

        resultData.push(genDirector());
        resultData.push(genAdmin());
        resultData.push(genFinance());
        resultData.push(genPlan());
        resultData.push(genEdu());
        resultData.push(genServe());
    }

    useEffect(() => {
        if (jsonfile === "lecturers") {
            getApi("lectures");
        } else if (jsonfile === "officers") {
            getApi("officers");
        }
    }, [jsonfile]);

    if (resData && jsonfile === "lecturers") {
        genLecturersJson(resData);
    } else if (resData && jsonfile === "officers") {
        genOfficersJson(resData);
    }

    return (
        <>
            {jsonfile ? (
                <div>
                    {/* ApiGenerator: {jsonfile} */}
                    {/* <hr /> */}
                    {/* {resData.length > 0 && <pre>{JSON.stringify(resData.filter((item) => item.titlePositionShort === "ศ."), null, 2)}</pre>} */}
                    {result.length > 0 && (
                        <pre>{JSON.stringify(result, null, 2)}</pre>
                    )}
                </div>
            ) : <div><a href="./officers" >/_admin/apigen/staff/officers</a> or <a href="./lecturers" >/_admin/apigen/staff/lecturers</a></div>}
        </>
    );
}
